import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getErrorLabel } from '@famly/vet_form-validators';
import { Text } from '@famly/mf_data-display_text';
import { Box } from '@famly/mf_layout_box';
const EMPTY_OBJ = {};
export const ReactOnMeta = (props) => {
    const { meta, children, validateIgnoreTouch } = props;
    const { touched, error } = meta || EMPTY_OBJ;
    const showErrors = validateIgnoreTouch ? Boolean(error) : touched && Boolean(error);
    return (_jsxs(_Fragment, { children: [children, showErrors ? (_jsx(Box, { className: "form-field-error", children: _jsx(Text, { variant: "body", color: "r400", children: getErrorLabel(error, props) }) }, "error")) : null] }));
};
export default ReactOnMeta;
